import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    returnHome: string;
    notFound: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            returnHome: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NotFoundLayout.returnHome?c=2o5lx8sjp90pc", defaultMessage: "Return Home" }));
                },
                enumerable: true,
                configurable: true
            },
            notFound: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NotFoundLayout.notFound?c=2l31jg7b1bdaj", defaultMessage: "Page not found" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
